export const PATH_APP = {
  root: '/',
  reception: '/reception',
  meetingRoom: '/meeting-room',
};
